import { createContext, useReducer, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import productReducer from '../products/ProductReducer'
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

const ProductContext = createContext()


const API_URL = process.env.REACT_APP_API_URL;

export const ProductProvider = ({ children }) => {

    const initialState = {
        oils: [],
        oil: {},
        additive: {},
        filter: {},
        relatedProducts: [],
        loading: false,
        manufacturer: '',
        selectedViscosities: [],
        totalPages: 0,
        currentPage: 1,
        cartItems: [],
        searchedProducts: [],
        searchedName: '',
        carName: ''
    }


    const [state, dispatch] = useReducer(productReducer, initialState)
    const [providerCartItems, setProviderCartItems] = useState(initialState.cartItems);

    const location = useLocation()
    const navigate = useNavigate();

    const fetchOils = async (manufacturer, viscosities, sortBy, pageSize, currentPage) => {
        try {
            setLoading()
            const viscosityQuery = viscosities.join(",");

            const response = await fetch(`${API_URL}/Item/oils?manufacturer=${manufacturer}&viscosities=${viscosityQuery}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`)

            if (response.status === 500 || response.status === 404) {
                dispatch({
                    type: 'GET_OILS',
                    payload: []
                })
            }
            const result = await response.json()
            if (result?.data?.items) {

                const newQueryParams = new URLSearchParams(location.search);
                dispatch({
                    type: 'GET_OILS',
                    payload: result.data.items
                })

                dispatch({
                    type: 'SET_TOTAL_PAGES',
                    payload: result.data.totalPages
                })

                if (result.data.totalPages) {
                    newQueryParams.set("totalPages", result.data.totalPages);
                }

                //navigate({ search: newQueryParams.toString() });
            } else {
                dispatch({
                    type: 'GET_OILS',
                    payload: []
                })
            }
        }
        catch (error) {
        }
    }


    const fetchOil = async (id) => {
        try {
            setLoading()
            const response = await fetch(`${API_URL}/item/oil/${id}`)

            if (response.status == 400) {
                dispatch({
                    type: 'GET_OIL',
                    payload: ''
                })
            }
            else {
                const result = await response.json()
                dispatch({
                    type: 'GET_OIL',
                    payload: result.data
                })
            }
        }
        catch (error) {
        }
    }

    const fetchAdditive = async (id) => {
        try {
            const response = await fetch(`${API_URL}/item/additive/${id}`)

            if (response.status == 400) {
                dispatch({
                    type: 'GET_ADDITIVE',
                    payload: ''
                })
            }
            else {
                const result = await response.json()
                dispatch({
                    type: 'GET_ADDITIVE',
                    payload: result.data
                })
            }
        }
        catch (error) {
        }
    }

    const fetchFilter = async (id) => {
        try {
            setLoading()
            const response = await fetch(`${API_URL}/item/carFilter/${id}`)

            if (response.status == 400) {
                dispatch({
                    type: 'GET_FILTER',
                    payload: ''
                })
            }
            else {
                const result = await response.json()
                dispatch({
                    type: 'GET_FILTER',
                    payload: result.data
                })
            }
        }
        catch (error) {
        }
    }

    const fetchRelatedProducts = async () => {
        try {
            const response = await fetch(`${API_URL}/item/oilRelatedProducts`)

            const result = await response.json()

            dispatch({
                type: 'GET_RELATED_PRODUCTS',
                payload: result.data
            })
        }
        catch (error) {
        }
    }

    const handlePageChange = (page) => {
        const newQueryParams = new URLSearchParams(location.search);

        if (page) {
            newQueryParams.set('currentPage', page); // Ако вредноста е присутна, додај ја во query параметрите
        } else {
            newQueryParams.delete('currentPage'); // Ако вредноста е празна, избриши ја
        }
        navigate({ search: newQueryParams.toString() });
        dispatch({
            type: 'SET_CURRENT_PAGE',
            payload: page
        })
    };

    const fetchSearchedProducts = async (searchedName, sortBy, pageSize, currentPage) => {
        try {
            const newQueryParams = new URLSearchParams(location.search);
            const response = await fetch(`${API_URL}/Item/products?name=${searchedName}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`);
            const result = await response.json();

            dispatch({
                type: 'GET_SEARCHED_PRODUCTS',
                payload: result.data.items
            })

            dispatch({
                type: 'SET_TOTAL_PAGES',
                payload: result.data.totalPages
            })

            if (result.data.totalPages) {
                newQueryParams.set("totalPages", result.data.totalPages);
            }

            navigate({ search: newQueryParams.toString() });
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const handleDeleteCartItems = (id) => {
        const updatedCartItems = providerCartItems.filter((item) => item.id !== id);

        // Ажурирање на состојбата на cartItems
        setCartItems(updatedCartItems);

        // Ажурирање на cart во cookies со новиот список
        Cookies.set('cart', JSON.stringify(updatedCartItems));
    };

    const setLoading = () => {
        dispatch({
            type: 'SET_LOADING'
        })
    }

    const setCurrentPage = (page) => {
        dispatch({
            type: 'SET_CURRENT_PAGE',
            payload: page
        })
    }

    const setTotalPages = (totalPages) => {
        dispatch({
            type: 'SET_TOTAL_PAGES',
            payload: totalPages
        })
    }

    const setSearchedName = (searchedName) => {
        dispatch({
            type: 'SET_SEARCHED_NAME',
            payload: searchedName
        })
    }

    const setCartItems = (cartItems) => {
        setProviderCartItems(cartItems)
        dispatch({
            type: 'SET_CART_ITEMS',
            payload: cartItems
        })
    }

    const addToCart = (item, quantity, carName) => {
        // Прво, пробај да ги добиеш сите производи од cookies
        const cartFromCookies = Cookies.get('cart') ? JSON.parse(Cookies.get('cart')) : [];

        // Проверка дали веќе постои производот во кошничката
        const existingItem = cartFromCookies.find((cartItem) => cartItem.id.toLowerCase() === item.id.toLowerCase() && cartItem.selectedCar === carName);

        if (existingItem) {
            // Ако производот веќе постои, ажурирај ја количината
            if ((existingItem.quantity + parseInt(quantity)) > item.stock) {
                return;
            }

            const finalPrice = item.discountedPrice > 0 ? item.discountedPrice : item.price;
            const originalPrice = item.price;

            const updatedCart = cartFromCookies.map(cartItem =>
                cartItem.id === item.id
                    ? {
                        ...cartItem,
                        quantity: parseInt(cartItem.quantity) + parseInt(quantity),
                        totalPrice: (parseInt(cartItem.quantity) + parseInt(quantity)) * finalPrice,
                        price: finalPrice,
                        originalPrice: originalPrice,
                        selectedCar: carName
                    }
                    : cartItem
            );

            let expirationTime = new Date();
            expirationTime.setMinutes(expirationTime.getMinutes() + 1440);

            // Зачувај ја ажурираната кошничка во cookies
            Cookies.set('cart', JSON.stringify(updatedCart), { expires: expirationTime });
            dispatch({
                type: 'SET_CART_ITEMS',
                payload: updatedCart
            })
            setProviderCartItems(updatedCart)
            
            dispatch({
                type: 'SET_CAR_NAME',
                payload: ''
            })

            toast.success(`${existingItem.title} е успешно додаден во кошничка!`);
        } else {
            // Ако производот не постои, додади нов производ во кошничката
            const hasDiscount = item.discountedPrice > 0;
            const finalPrice = hasDiscount ? item.discountedPrice : item.price;

            const newItem = {
                title: item.title,
                price: finalPrice,
                originalPrice: item.price,
                imageLink: item.imageLinks && item.imageLinks[0]?.imageLink ? item.imageLinks[0].imageLink : '',
                id: item.id,
                quantity: parseInt(quantity), // користи количината од инпутот
                stock: item.stock,
                totalPrice: finalPrice * parseInt(quantity),
                selectedCar: carName
            };

            // Додади го новиот производ во кошничката
            const updatedCart = [...cartFromCookies, newItem];

            let expirationTime = new Date();
            expirationTime.setMinutes(expirationTime.getMinutes() + 1440);

            // Зачувај ја новата кошничка во cookies
            Cookies.set('cart', JSON.stringify(updatedCart), { expires: expirationTime });
            dispatch({
                type: 'SET_CART_ITEMS',
                payload: updatedCart
            })
            setProviderCartItems(updatedCart)

            dispatch({
                type: 'SET_CAR_NAME',
                payload: ''
            })

            toast.success(`${newItem.title} е успешно додаден во кошничка!`);
        }
    };

    const getCarName = async (engineId) => {
        try {
            const response = await fetch(`${API_URL}/car/carName/${engineId}`)

            const result = await response.json()

            dispatch({
                type: 'GET_CAR_NAME',
                payload: result.data
            })
        }
        catch (error) {
        }
    }

    return <ProductContext.Provider value={{
        oils: state.oils,
        oil: state.oil,
        additive: state.additive,
        relatedProducts: state.relatedProducts,
        loading: state.loading,
        fetchOils,
        fetchOil,
        fetchAdditive,
        fetchRelatedProducts,
        totalPages: state.totalPages,
        currentPage: state.currentPage,
        setCurrentPage,
        setTotalPages,
        handlePageChange,
        addToCart,
        cartItems: state.cartItems,
        setCartItems,
        handleDeleteCartItems,
        fetchFilter,
        filter: state.filter,
        searchedProducts: state.searchedProducts,
        fetchSearchedProducts,
        setSearchedName,
        searchedName: state.searchedName,
        carName: state.carName,
        getCarName
    }}>
        {children}
    </ProductContext.Provider>
}

export default ProductContext